import { get, httpDelete, patch, post } from '../../utils/http';

export const addProjects = ({ accountId, branchId, projects, isSchedulingBoard, bulk }) =>
  post(`/accounts/${accountId}/branches/${branchId}/projects`, { projects, isSchedulingBoard, bulk });

export const fetchProject = ({ accountId, branchId, projectId, includes = [], isLite, withPayroll = true, context }) =>
  get(`/accounts/${accountId}/branches/${branchId}/projects/${projectId}`, { includes, isLite, withPayroll, context });

export const updateProject = ({
  accountId,
  branchId,
  projectId,
  project,
  deleteEmptyProject = false,
  applyShiftDeletionToLinkedShifts
}) =>
  patch(`/accounts/${accountId}/branches/${branchId}/projects/${projectId}`, {
    ...project,
    deleteEmptyProject,
    ...(applyShiftDeletionToLinkedShifts !== undefined && { applyShiftDeletionToLinkedShifts })
  });

export const bookEmployeeToProject = ({
  accountId,
  branchId,
  projectId,
  shiftId,
  employeeId,
  enableWtdCheck = true,
  enableComplianceCheck = true,
  specificShiftIds
}) =>
  post(`/accounts/${accountId}/branches/${branchId}/projects/${projectId}/book`, {
    employeeId,
    preferredShiftId: shiftId,
    enableWtdCheck,
    enableComplianceCheck,
    specificShiftIds
  });

export const publishProjectEmployeeSlot = ({
  accountId,
  branchId,
  projectId,
  employeeSlotsIds,
  consolidate,
  bypassComplianceWarnings
}) =>
  post(`/accounts/${accountId}/branches/${branchId}/projects/${projectId}/broadcast/slots`, {
    ids: employeeSlotsIds,
    consolidate,
    bypassComplianceWarnings
  });

export const exportProjectForecastingReport = ({ accountId, branchId, projectId }) =>
  get(`/accounts/${accountId}/branches/${branchId}/projects/${projectId}/forecasting-report`);

export const fetchProjectInfo = ({ accountId, branchId, projectId }) =>
  get(`/accounts/${accountId}/branches/${branchId}/projects/${projectId}/info`);

export const exportProjectInvoice = ({ accountId, branchId, projectId }) =>
  post(`/accounts/${accountId}/branches/${branchId}/projects/${projectId}/invoice`);

export const changeShiftExternalEmployee = ({
  accountId,
  branchId,
  projectId,
  srcClientShiftId,
  dstClientShiftId,
  originSupplierEmployeeSlotId,
  directSupplierProjectId
}) =>
  patch(`/accounts/${accountId}/branches/${branchId}/projects/${projectId}/os-change-shift`, {
    srcClientShiftId,
    dstClientShiftId,
    originSupplierEmployeeSlotId,
    directSupplierProjectId
  });

export const swapShift = ({ accountId, branchId, projectId, src, dst, withValidations }) =>
  post(`/accounts/${accountId}/branches/${branchId}/projects/${projectId}/swap-shift`, { src, dst, withValidations });

export const fetchPresentationInfo = ({ accountId, branchId, projectId }) =>
  get(`/accounts/${accountId}/branches/${branchId}/projects/${projectId}/presentationInfo`);

export const refreshProjectStats = ({ accountId, branchId, projectId }) =>
  post(`/accounts/${accountId}/branches/${branchId}/projects/${projectId}/refresh-stats`);

export const updateProjectRegistration = ({ accountId, branchId, projectId, isPaused, message }) =>
  patch(`/accounts/${accountId}/branches/${branchId}/projects/${projectId}/registration`, { isPaused, message });

export const fetchAvailableEmployees = ({ accountId, branchId, projectId, name, showRejected }) =>
  get(`/accounts/${accountId}/branches/${branchId}/projects/availability`, {
    name,
    projectIds: [projectId],
    pageSize: 500,
    page: 0,
    kinds: showRejected ? ['applied', 'applied-rejection', 'available-rejection'] : ['applied'],
    warnings: true,
    info: true
  });

export const publishProjects = ({ accountId, branchId, projectIds, consolidate, bypassComplianceWarnings }) =>
  post(`/accounts/${accountId}/branches/${branchId}/projects/broadcast`, {
    ids: projectIds,
    consolidate,
    bypassComplianceWarnings
  });

export const copyProjects = ({ accountId, branchId, data }) =>
  post(`/accounts/${accountId}/branches/${branchId}/projects/copy`, data);

export const fetchProjectHourly = ({ accountId, branchId, from, to }) =>
  get(`/accounts/${accountId}/branches/${branchId}/projects/hourly`, { from, to });

export const publishProjectsApplications = ({ accountId, branchId, data, emptyShiftsOnly, withPush }) =>
  post(`/accounts/${accountId}/branches/${branchId}/projects/publish`, { data, emptyShiftsOnly, withPush });

export const pauseProjectApplicationsInRange = ({ accountId, branchId, data }) =>
  post(`/accounts/${accountId}/branches/${branchId}/projects/pause-in-range`, { data });

export const broadcastProjectsInRange = ({ accountId, branchId, data, consolidate }) =>
  post(`/accounts/${accountId}/branches/${branchId}/projects/broadcast-in-range`, { data, consolidate });

export const unbookProjectsShiftsInRange = ({ accountId, branchId, from, to }) =>
  post(`/accounts/${accountId}/branches/${branchId}/projects/shifts/unbook`, { from, to });

export const deleteProject = ({ accountId, branchId, projectId, message }) =>
  httpDelete(`/accounts/${accountId}/branches/${branchId}/projects/${projectId}`, { message });

export const deleteProjectsBulk = ({ accountId, branchId, projectIds, message }) =>
  httpDelete(`/accounts/${accountId}/branches/${branchId}/projects/bulk`, { projectIds, message });

export const getDeleteProjectErrors = ({ accountId, branchId, projectId }) =>
  get(`/accounts/${accountId}/branches/${branchId}/projects/${projectId}/calculate-delete-errors`);

export const getDeleteProjectsErrors = ({ accountId, branchId, projectIds }) =>
  post(`/accounts/${accountId}/branches/${branchId}/projects/calculate-delete-errors`, { projectIds });

export const saveWeeklyPlanners = ({ accountId, branchId, data }) =>
  post(`/accounts/${accountId}/branches/${branchId}/projects/save-weekly-planners`, data);

export const loadWeeklyPlanner = ({ accountId, branchId, data }) =>
  post(`/accounts/${accountId}/branches/${branchId}/projects/load-weekly-planner`, data);
